import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Home } from "./pages/Home";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsAndConditions } from "./pages/TermsAndConditions";
import { EliminarCuenta } from "./pages/EliminarCuenta";

function App() {
  return (
    <Router>
      <div className="bg-background text-foreground">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsAndConditions />} />
          <Route path="/eliminar-cuenta" element={<EliminarCuenta />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
